'use strict';

angular.module('shiftTraderApp')
  .factory('ShiftTemplates', function (ServerUrls, $http, $q, Session, $injector) {
    var url = ServerUrls.current.railsApi + 'shift_templates';

    //SHIFT MODEL OBJECT
    var ShiftTemplate = function(initData) {
      var st = {};
      angular.extend(st, initData);

      var Shifts = $injector.get('Shifts');

      st.shifts = _.map(st.shifts, function(s) {
        return new Shifts.initWithData(s);
      });

      st.$calcTotalHours = function() {
        st._totalHours = _.reduce(st.shifts, function(sum, shift) {
          return sum + shift._lengthInHours;
        }, 0);
      };

      st.$calcTotalHours();

      st.$update = function(newData) {
        var that = this;

        var data = {
          id: this.id,
          organization_id: this.organization.id || this.organization_id
        };
        angular.extend(data, newData);

        return $http.put(url + '/' + this.id, data)
          .then(function (response) {
              that.name = response.data.name;
              that.active = response.data.active;
              that.description = response.data.description;
              that.archived = response.data.archived;
              that.archived_at = response.data.archived_at;
              that.archived_by_id = response.data.archived_by_id;
              return response.data;
          }, function(resp) {
            return $q.reject(resp);
          });
      };

      st.$archive = function() {
        return st.$update({archived: true});
      };

      return st;
    };

    //SHIFTS CREATE/QUERY LAYER
    var ShiftTemplates = {};

    ShiftTemplates.initWithData = function(initData) {
      return new ShiftTemplate(initData);
    };

    ShiftTemplates.getAll = function(params) {
      var config = {
        params: {
          'organization_id': Session.getCurrentOrgId()
        }
      };

      if (angular.isDefined(params)) {
        angular.extend(config.params, params);
      }

      return $http.get(url, config)
        .then(function (response) {
          return _.map(response.data, function(x) {
            return ShiftTemplates.initWithData(x);
          });
        }, function(response) {
          return $q.reject(response);
        });
    };

    ShiftTemplates.create = function(data) {
      return $http.post(url, data)
        .then(function(response) {
          return new ShiftTemplate(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    return ShiftTemplates;
  });
